import React, { ReactNode } from 'react';
import { XIcon } from 'lucide-react';
export function Field({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  hint
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  hint?: string;
}) {
  return <label className="block" data-id="element-203" data-mp="4ocioikfrxhf">
      <span className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-204" data-mp="4pdxmy4kp44f">{label}</span>
      <input type={type} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-3 text-sm text-gray-900 outline-none transition-colors focus:border-black" data-id="element-205" data-mp="3d57h9lu7avpp" />
      {hint && <span className="mt-1 block text-xs text-gray-400" data-id="element-206" data-mp="3i2fxhgvsgpob">{hint}</span>}
    </label>;
}
export function TextArea({
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  hint
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  hint?: string;
}) {
  return <label className="block" data-id="element-207" data-mp="uwo9oifxs7fs">
      <span className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-208" data-mp="uvv0lati95uh">{label}</span>
      <textarea rows={rows} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-3 text-sm text-gray-900 outline-none transition-colors focus:border-black" data-id="element-209" data-mp="zoftma4l7ewy" />
      {hint && <span className="mt-1 block text-xs text-gray-400" data-id="element-210" data-mp="bylgrsk9pqcp">{hint}</span>}
    </label>;
}
export function Modal({
  title,
  onClose,
  children,
  footer
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return <div className="fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-black/40 p-6 backdrop-blur-sm" data-id="element-211" data-mp="1resx4if2c3ht">
      <div className="my-10 w-full max-w-3xl rounded-3xl bg-white shadow-floating" data-id="element-212" data-mp="1wcm3bbgd8xi3">
        <div className="flex items-center justify-between border-b border-gray-100 px-8 py-6" data-id="element-213" data-mp="3sg8wg38wqk7f">
          <h2 className="font-display text-2xl font-medium text-gray-900" data-id="element-214" data-mp="3ofq3g5va383n">{title}</h2>
          <button onClick={onClose} aria-label="Stäng" className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-gray-200" data-id="element-215" data-mp="69brgcgkl87w">
            <XIcon className="h-4 w-4" data-id="element-216" data-mp="39rc444x2m1ru" />
          </button>
        </div>
        <div className="px-8 py-6" data-id="element-217" data-mp="34rhdm2h7je7b">{children}</div>
        {footer && <div className="flex justify-end gap-3 border-t border-gray-100 px-8 py-5" data-id="element-218" data-mp="34t0qdj3nn74c">{footer}</div>}
      </div>
    </div>;
}
export function PrimaryButton({
  children,
  onClick,
  type = 'button'
}: {
  children: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
}) {
  return <button type={type} onClick={onClick} className="rounded-full bg-black px-6 py-3 text-sm font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-219" data-mp="2qxyca8onmbgg">
      {children}
    </button>;
}
export function GhostButton({
  children,
  onClick
}: {
  children: ReactNode;
  onClick?: () => void;
}) {
  return <button type="button" onClick={onClick} className="rounded-full border border-gray-200 bg-white px-6 py-3 text-sm font-medium text-gray-900 transition-colors hover:bg-gray-50" data-id="element-220" data-mp="shz91agx1iar">
      {children}
    </button>;
}